import { IconButton } from "@mui/material";
import { XIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";

type DrawerTopBarProps = {
  onCloseClick?: () => void;
  titleCentered?: boolean;
  title: ReactNode;
};

export function DrawerTopBar({
  onCloseClick,
  titleCentered = true,
  title,
}: DrawerTopBarProps) {
  return (
    <div className="mb-3 flex min-h-11 items-center">
      {onCloseClick ? (
        <IconButton onClick={onCloseClick} aria-label="close drawer">
          <XIcon size={24} color="var(--color-text-tertiary)" />
        </IconButton>
      ) : null}

      <h2 className="grow text-center text-lg font-medium">{title}</h2>

      {onCloseClick && titleCentered ? (
        <div className="size-10 shrink-0" />
      ) : null}
    </div>
  );
}

type DrawerToBarWithActionProps = DrawerTopBarProps & {
  actionElement?: ReactNode;
};

export function DrawerTopBarWithAction({
  onCloseClick,
  title,
  actionElement,
}: DrawerToBarWithActionProps) {
  return (
    <div className="grid min-h-11 grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-2">
      <IconButton
        onClick={onCloseClick}
        className="justify-self-start"
        aria-label="close drawer"
      >
        <XIcon size={24} color="var(--color-text-tertiary)" />
      </IconButton>
      <div className="justify-self-center overflow-hidden text-lg text-ellipsis whitespace-nowrap">
        {title}
      </div>
      <div className="justify-self-end">{actionElement}</div>
    </div>
  );
}
